export enum ModalOrder {
  ACCEPT_TERMS_POPUP = 'accept-terms-popup',
  TUTORIAL_POPUP = 'tutorial-popup',
  CHARGE_TIMELINE_DAYS_POPUP = 'charge-timeline-days-popup',
  PAYMENT_METHOD_SUCCESS_POPUP = 'payment-method-success-popup',
  CARD_SUCCESS_POPUP = 'card-success-popup',
  BANK_SUCCESS_POPUP = 'bank-success-popup',
  SUSPENDED_POSTINGS_POPUP = 'suspended-postings-popup',
}

export const MODAL_ORDER_LIST = [
  ModalOrder.ACCEPT_TERMS_POPUP,
  ModalOrder.TUTORIAL_POPUP,
  ModalOrder.CHARGE_TIMELINE_DAYS_POPUP,
  ModalOrder.PAYMENT_METHOD_SUCCESS_POPUP,
  ModalOrder.CARD_SUCCESS_POPUP,
  ModalOrder.BANK_SUCCESS_POPUP,
  ModalOrder.SUSPENDED_POSTINGS_POPUP,
];
